module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"orderType":"Order Type","selectOrderType":"Select order type"},"no":{"orderType":"Type Oppdrag","selectOrderType":"Velg oppdragstype"}}')
  delete Component.options._Ctor
}
